<template>
  <div class="footer-button-container">
    <button class="popup-footer-button secondary-button" :disabled="!exportButtonsAreEnabled" @click="handleFooterButtonClick('ChangeExportDataSelection')">
      {{ $t('export.label.editSelection') }}
      <i class="fa-regular fa-square-check"></i>
    </button>
    <button v-show="!!selectedExportItemConfig?.preExportChecks" class="popup-footer-button primary-button" :disabled="!exportButtonsAreEnabled" @click="handleFooterButtonClick('PreExportCheck')">
      {{ $t('export.label.next') }}
      <i class="fa-regular fa-chevron-right"></i>
    </button>
    <button v-show="!selectedExportItemConfig?.preExportChecks" class="popup-footer-button primary-button" :disabled="!exportButtonsAreEnabled" @click="handleFooterButtonClick('CreateExport')">
      {{ $t('label.export') }}
      <i class="fa-regular fa-cloud-download"></i>
    </button>
  </div>
</template>

<script>
import '@/assets/less/colors.less'

export default {
  name: 'SelectExportTypeFooter',
  props: {
    exportButtonsAreEnabled: {
      type: Boolean,
      required: true
    },
    selectedExportItemConfig: {
      type: Object,
      required: false
    }
  },
  methods: {
    handleFooterButtonClick(page) {
      this.$emit('setNextPage', { nextComponent: page, nextFooter: `${page}Footer` })
      this.$emit('goNextPage')
    }
  }
}
</script>
